"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
exports.ModalContainer = void 0;
var react_1 = __importStar(require("react"));
var utils_1 = require("@lglp/utils");
var portal_1 = require("../../helpers/portal");
var Container_1 = require("../Container");
var ModalContext_1 = require("./ModalContext");
exports.ModalContainer = react_1.memo(function (props) {
    var _a = ModalContext_1.useModalContext(), opened = _a.opened, toggleOpen = _a.toggleOpen;
    var _b = props.as, as = _b === void 0 ? 'aside' : _b, _c = props.modalPortalId, modalPortalId = _c === void 0 ? portal_1.DEFAULT_PORTAL_ID : _c, className = props.className, rest = __rest(props, ["as", "modalPortalId", "className"]);
    react_1.useEffect(function () {
        utils_1.disableGlobalScroll(opened);
        return function () {
            utils_1.disableGlobalScroll(false);
        };
    }, [opened]);
    var onKeyDown = function (_a) {
        var key = _a.key;
        // "Esc" for ie 11
        if (key === 'Escape' || key === 'Esc') {
            toggleOpen(false);
        }
    };
    if (!opened) {
        return null;
    }
    return portal_1.createPortal(react_1["default"].createElement(Container_1.Container, __assign({ as: as, role: "dialog", tabIndex: "-1", "aria-modal": "true", onKeyDown: onKeyDown, className: ['modal_container', className] }, rest)), modalPortalId);
});
//# sourceMappingURL=ModalContainer.js.map